/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

Vue.use(Vuex);

import moduleEditor from "./editor/moduleEditor.js";
import moduleParser from "./parser/moduleParser.js";
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAlex from "./alex/moduleAlex.js";
import moduleJourney from "./journey/moduleJourney.js";
import moduleEmotionHack from "./emotionhack/moduleJEmotionHack.js";
import moduleAuth from "./auth/moduleAuth.js";
import moduleUsers from "./users/moduleUsers.js";
import moduleOrganization from "./organization/moduleOrganization.js";
import moduleBoards from "./boards/moduleBoards.js";
import moduleKanban from "./kanban/moduleKanban.js";
// import moduleOrganizationMessages from './organization-messages/moduleOrganizationMessages.js'
import moduleUserChat from "./user-chat/moduleChat.js";
import moduleOrganizationChat from "./organization-chat/moduleChat.js";
import modulePlanner from "./planner/modulePlanner.js";
import moduleFeed from "./feed/moduleFeed.js";
import modulePayments from "./payments/modulePayments";
import moduleVideowiki from "./videowiki/moduleVideowiki";
import moduleDashboard from "./dashboard/moduleDashboard";
import moduleCoach from "./coach/moduleCoach";
import moduleModel from "./modals/moduleModals";
import moduleMarket from "./market/moduleMarket";
import moduleAnimation from "./animation/moduleAnimation";
import moduleIntegration from "./integrations/moduleIntegrations";
import moduleCommunity from "./community/moduleCommunity";
import moduleBot from "./bot/moduleBot";
import moduleQuiz from "./quiz/moduleQuiz";
import moduleKVDR from "./kvdr/moduleKVDR";
import moduleTalentPlanPayments from "./talent-plan-payments/moduleTalentPlanPayments";

export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    userChat: moduleUserChat,
    organizationChat: moduleOrganizationChat,
    // email: moduleEmail,
    // auth: moduleAuth,
    editor: moduleEditor,
    parser: moduleParser,
    alex: moduleAlex,
    journey: moduleJourney,
    emotionhack: moduleEmotionHack,
    auth: moduleAuth,
    users: moduleUsers,
    organization: moduleOrganization,
    boards: moduleBoards,
    kanban: moduleKanban,
    planner: modulePlanner,
    feed: moduleFeed,
    payments: modulePayments,
    videowiki: moduleVideowiki,
    dashboard: moduleDashboard,
    coach: moduleCoach,
    modals: moduleModel,
    market: moduleMarket,
    animation: moduleAnimation,
    integrtions: moduleIntegration,
    community: moduleCommunity,
    bot: moduleBot,
    quiz: moduleQuiz,
    kvdr: moduleKVDR,
    talentPlanPayments: moduleTalentPlanPayments,
  },
  strict: process.env.NODE_ENV !== "production",
});
